import { get } from "../../services/axiosUitils";

export default class ZulipService {
  static getZulipToken = async (): Promise<any> => {
    return await get("auth/zulip/zulip-token/");
  };
}
